import { __awaiter, __decorate, __metadata } from "tslib";
import { inject, injectable, postConstruct } from 'mana-syringe';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
import { XFlowGraphCommands } from '../constant';
export var NsGraphFullscreen;
(function (NsGraphFullscreen) {
    /** Command: 用于注册named factory */
    NsGraphFullscreen.command = XFlowGraphCommands.GRAPH_FULLSCREEN;
    /** hookName */
    NsGraphFullscreen.hookKey = 'graphFullscreen';
})(NsGraphFullscreen || (NsGraphFullscreen = {}));
let GraphFullscreenCommand = 
/** 画布Fullscreen命令 */
class GraphFullscreenCommand {
    constructor() {
        /** 执行Cmd */
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const { args, hooks: runtimeHook } = this.ctx.getArgs();
            const hooks = this.ctx.getHooks();
            const config = yield this.ctx.getGraphConfig();
            // @ts-ignore
            const { appContainer } = config;
            if (!appContainer) {
                return;
            }
            const result = yield hooks.graphFullscreen.call(
            /** 执行hooks pipeline处理args */
            args, 
            /** 执行 callback */
            () => __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                let fulllscreen = false;
                if (!document.fullscreenElement) {
                    (_a = appContainer.requestFullscreen) === null || _a === void 0 ? void 0 : _a.call(appContainer);
                    fulllscreen = true;
                }
                else {
                    (_b = document.exitFullscreen) === null || _b === void 0 ? void 0 : _b.call(document);
                }
                return { fulllscreen };
            }), 
            /** execute command 时创建的hook */
            runtimeHook);
            /** 设置结果 */
            this.ctx.setResult(result);
            return this;
        });
        /** undo cmd */
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            this.ctx.undo();
            return this;
        });
        /** redo cmd */
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.ctx.isUndoable) {
                yield this.execute();
            }
            return this;
        });
    }
    init() {
        this.ctx = this.contextProvider();
    }
    /** isUndoable */
    isUndoable() {
        return this.ctx.isUndoable();
    }
};
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], GraphFullscreenCommand.prototype, "contextProvider", void 0);
__decorate([
    postConstruct(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], GraphFullscreenCommand.prototype, "init", null);
GraphFullscreenCommand = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsGraphFullscreen.command.id },
    })
    /** 画布Fullscreen命令 */
], GraphFullscreenCommand);
export { GraphFullscreenCommand };
//# sourceMappingURL=graph-fulllscreen.js.map